<template>
  <HeadComponent />

  <section class="menu py-5">
    <div class="container">
      <div class="flex flex-wrap items-center">
        <div class="flex items-center w-1/6 lg:w-0">
          <button @click="toggleMenu">
            <template v-if="$page.props.darkModeEnabled">
              <img src="/frontend/assets/menu-white.svg">
            </template>
            <template v-else>
              <img src="/frontend/assets/menu.svg">
            </template>
          </button>
        </div>

        <div class="w-4/6 flex justify-center lg:w-3/12 lg:justify-start">
          <Link
            :href="localeRoute('frontend.index')"
            :title="__('general.site.name')"
          >
            <img
              src="/frontend/assets/logo.svg"
              :alt="__('general.site.name')"
            >
          </Link>
        </div>

        <div class="hidden lg:flex lg:w-9/12 lg:justify-end">
          <Link
            :href="localeRoute('frontend.vip-signup')"
            class="button-orange shadow-button-black inline-block !py-2 !px-4 text-sm whitespace-nowrap"
          >
            {{ __('layouts.default.menu.vip-signup') }}
          </Link>
        </div>

        <div
          v-show="menuIsOpen"
          class="fixed top-0 bottom-0 left-0 right-0 bg-red-100 dark:bg-gray-900 z-40 lg:z-auto lg:hidden lg:w-9/12"
        >
          <div class="flex items-stretch flex-wrap h-full lg:block">
            <div class="flex flex-col w-full space-y-6 p-9 lg:p-0 lg:space-y-0 lg:flex-row lg:flex-nowrap lg:items-center lg:space-x-5 xl:space-x-8 lg:justify-end">
              <div class="w-full lg:hidden lg:w-auto">
                <button @click="toggleMenu">
                  <img src="/frontend/assets/close.svg">
                </button>
              </div>

              <div
                v-if="false"
                v-show="countries.length > 1"
                class="w-full lg:order-last lg:w-[23px] lg:h-[23px]"
              >
                <button
                  v-for="(value, index) in countries"
                  v-show="index === 0 || showCountries"
                  :key="value.country"
                  @click="showCountries ? changeCountry(value.country) : showCountries = true"
                >
                  <img
                    :src="`/frontend/assets/country/${value.country}.svg`"
                    :alt="value.country"
                  >
                </button>
              </div>

              <Link
                v-if="country === 'nl'"
                :href="localeRoute('frontend.booking.index')"
                class="text-4xl font-bold hover:underline lg:text-base lg:font-normal dark:text-white"
                @click="closeMenu"
              >
                {{ __('layouts.default.menu.book-event') }}
              </Link>
              <Link
                :href="localeRoute('frontend.how-does-it-work')"
                class="text-4xl font-bold hover:underline lg:text-base lg:font-normal dark:text-white"
                @click="closeMenu"
              >
                {{ __('layouts.default.menu.how-does-it-work') }}
              </Link>
              <Link
                :href="localeRoute('frontend.business')"
                class="text-4xl font-bold hover:underline lg:text-base lg:font-normal dark:text-white"
                @click="closeMenu"
              >
                {{ __('layouts.default.menu.business') }}
              </Link>
              <Link
                :href="localeRoute('frontend.news.index')"
                class="text-4xl font-bold hover:underline lg:text-base lg:font-normal dark:text-white"
                @click="closeMenu"
              >
                {{ __('layouts.default.menu.news') }}
              </Link>
              <Link
                :href="localeRoute('frontend.about-us')"
                class="text-4xl font-bold hover:underline lg:text-base lg:font-normal dark:text-white"
                @click="closeMenu"
              >
                {{ __('layouts.default.menu.about-us') }}
              </Link>
              <Link
                :href="localeRoute('frontend.contact')"
                class="text-4xl font-bold hover:underline lg:text-base lg:font-normal dark:text-white"
                @click="closeMenu"
              >
                {{ __('layouts.default.menu.contact') }}
              </Link>
              <Link
                :href="localeRoute('frontend.vip-signup')"
                class="text-4xl font-bold hover:underline lg:text-base lg:font-normal dark:text-white"
                @click="closeMenu"
              >
                {{ __('layouts.default.menu.vip-signup') }}
              </Link>
            </div>

            <div class="self-end border-t border-t-gray-200 p-9 w-full space-y-4 lg:hidden dark:text-white">
              <Link
                :href="localeRoute('frontend.privacy-statement')"
                class="block"
                @click="closeMenu"
              >
                {{ __('layouts.default.privacy') }}
              </Link>
              <Link
                :href="localeRoute('frontend.terms-and-conditions')"
                class="block"
                @click="closeMenu"
              >
                {{ __('layouts.default.terms') }}
              </Link>
              <span class="block">
                <i18n-t
                  keypath="layouts.default.copyright"
                  scope="global"
                >
                  <template #year>
                    {{ new Date().getFullYear() }}
                  </template>
                </i18n-t>
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>

  <div
    v-if="!isVipSignupPage"
    class="container lg:hidden py-3 text-center"
  >
    <Link
      :href="localeRoute('frontend.vip-signup')"
      class="button-orange shadow-button-black inline-block text-sm !py-2 !px-6"
    >
      {{ __('layouts.default.menu.vip-signup') }}
    </Link>
  </div>

  <slot />

  <div
    v-if="lastPurchaseDialog && lastPurchaseData"
    class="fixed right-0 bottom-0 mx-2 content-start border-2 border-b-0 border-black rounded-t-xl p-3 flex flex-col lg:flex-row home-vips-item bg-white !flex-col text-center z-50"
  >
    {{ __(lastPurchaseTranslation, {
      customer: lastPurchaseData.first_name,
      minutes: lastPurchaseData.minutes_ago,
      hours: lastPurchaseData.hours_ago,
      vip: lastPurchaseData.vip
    }) }}
  </div>

  <FooterComponent :country="country" />
</template>

<script>
import axios from 'axios';
import HeadComponent from './Components/Head.vue';
import FooterComponent from './Components/Footer.vue';

export default {
  components: {
    HeadComponent,
    FooterComponent,
  },

  props: {
    countries: {
      type: Object,
      required: true,
    },

    country: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      preHeaderSliderOptions: {
        type: 'loop',
        arrows: false,
        pagination: false,
        drag: false,
        autoplay: true,
        interval: 5000,
        perPage: 3,
        breakpoints: {
          1024: { perPage: 1 },
        },
      },

      showCountries: false,
      menuOpen: false,

      trackPageChangeForLastPurchaseDialog: false,
      lastPurchaseDialog: false,
      lastPurchaseData: null,
      lastPurchaseTranslation: '',
    };
  },

  computed: {
    menuIsOpen() {
      return this.$isDesktop || this.menuOpen;
    },

    isVipSignupPage() {
      return route().current().endsWith('.frontend.vip-signup');
    },
  },

  mounted () {
    if (!this.$page.props.lastPurchaseDialogShown) {
      this.trackTime();
    }

    const htmlElement = document.getElementsByTagName('html')[0];
    this.$inertia.on('navigate', (e) => {
      if (e.detail.page.props.darkModeEnabled && !htmlElement.classList.contains('dark')) {
        htmlElement.classList.add('dark');
      } else if (!e.detail.page.props.darkModeEnabled && htmlElement.classList.contains('dark')) {
        htmlElement.classList.remove('dark');
      }
    });
  },

  methods: {
    trackTime() {
      setTimeout(() => this.trackPageChange(), 45000);
    },

    isHomePage() {
      let currentRoute = this.$page.props.routeName;
      return currentRoute.includes('.frontend.index');
    },

    trackPageChange() {
      if (
        route().current().endsWith('.frontend.vips.index')
        || route().current().endsWith('.frontend.vips.show')
        || route().current().endsWith('.frontend.categories.slug')
      ) {
        axios.get(this.localeRoute('frontend.api.last-purchase'))
          .then(({data}) => {
            if (data.success) {
              this.lastPurchaseDialog = true;
              this.lastPurchaseData = data;
              this.lastPurchaseTranslation = data.minutes_ago < 60 ? 'layouts.components.last-purchase.text_minutes' : 'layouts.components.last-purchase.text_hours';
            }
          });
      } else {
        setTimeout(() => this.trackPageChange(), 2000);
      }
    },

    toggleMenu() {
      document.body.classList.toggle('overflow-y-hidden');
      document.body.classList.toggle('fixed');

      this.menuOpen = !this.menuOpen;
    },

    closeMenu() {
      document.body.classList.remove('overflow-y-hidden');
      document.body.classList.remove('fixed');

      this.menuOpen = false;
    },

    changeCountry(country) {
      let currentRoute = this.route().current();
      currentRoute = currentRoute.slice(3);
      currentRoute = country + '.' + currentRoute;

      window.location = this.route(currentRoute);
    },
  },
};
</script>
